"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _FinproProfileUtility = require("./FinproProfileUtility");
var _CTAButton = _interopRequireDefault(require("../CTAButton"));
var _richTextField = require("../../lib/richTextField");
var _ResultNotFound = _interopRequireDefault(require("./ResultNotFound"));
var _MultiplePinMap = require("./maps/MultiplePinMap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 *  A react component to list finpro agents
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.agencyList agency list to display
 *
 * @returns {React.ReactElement} list of agents
 */
function CityAgencyList(props) {
  var [hoverId, setHoverId] = (0, _react.useState)('');
  var GetAgencyDetail = props => {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
      className: "container"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      lg: 6,
      md: 6,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.OfficeTitleLink, {
      officeTitle: props.agencyName,
      titleSize: 'h3',
      officeLink: props.agencyUrl
    }), /*#__PURE__*/_react.default.createElement("h4", null, props.officeType), /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetAddress, props.location)))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      lg: 6,
      md: 6,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, !(0, _lodash.isEmpty)(props.location.phone) && /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetPhone, {
      value: props.location.phone
    }), !(0, _lodash.isEmpty)(props.agencyWebsiteUrl) && /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
      buttonType: 'inline',
      target: '_blank',
      label: 'Visit Agency Website',
      icon: 'icon-external-link',
      iconDirection: 'left',
      href: props.agencyWebsiteUrl
    })))));
  };
  if (props.agencyList && props.agencyList.length > 0) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      lg: 8,
      md: 12,
      sm: 12
    }, (0, _lodash.map)(props.agencyList, (agency, agencyIndex) => {
      return /*#__PURE__*/_react.default.createElement("section", {
        key: agencyIndex,
        onMouseOver: () => {
          setHoverId(agencyIndex);
        }
      }, /*#__PURE__*/_react.default.createElement(GetAgencyDetail, agency), /*#__PURE__*/_react.default.createElement("hr", null));
    }), !(0, _lodash.isEmpty)(props.disclaimer) && /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, (0, _richTextField.parseHTML)(props.disclaimer))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      lg: 4,
      className: "mm-desktop-only map-col neg-margin"
    }, /*#__PURE__*/_react.default.createElement(_MultiplePinMap.MultiplePinMap, {
      agencyList: props.agencyList,
      hoverId: hoverId,
      setHoverId: setHoverId
    })));
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResultNotFound.default, {
      noResultMessage: 'No matching results for your location'
    }), /*#__PURE__*/_react.default.createElement("hr", null), !(0, _lodash.isEmpty)(props.disclaimer) && /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, (0, _richTextField.parseHTML)(props.disclaimer)));
  }
}
var _default = exports.default = CityAgencyList;